import { Component, OnInit } from '@angular/core';
import {UserService} from '../../service/user.service';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-packages',
  templateUrl: './packages.component.html',
  styleUrls: ['./packages.component.css']
})
export class PackagesComponent implements OnInit {
  package: any;
  category: any;
  extra: any;
  details: any;
  isloading: boolean;

  constructor(private userService:UserService,private route:Router,private modalService: NgbModal,private scrollToService: ScrollToService,) { }
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 5
      },
      900: {
        items: 8
      }
    },
    nav: false
  };
  ngOnInit(): void {
    this.getallCatogry();
    this.triggerScrollTo();

  }

  getallCatogry(){
    this.userService.getallCategorys().subscribe(
        res=>{
          this.category = res.data;
          this.package = res.data;
          this.extra = res.data;
          this.pacbyCategory(this.category[0].id);
        }
    )
  }

  catogrySearch(id){
    // let req ={
    //   type:id,
    // }
    // this.userService.getallCategorys(req).subscribe(
    //     res=>{
    //       this.package = res.data;
    //     }
    // )
  }

  search(pac) {
    console.log(pac)
    let ar: Array<any> = [];
    ar.push(pac);
    this.package=ar;
  }

  all() {
  this.package =this.extra;
  }

  booking(p: any) {
    localStorage.setItem('package',JSON.stringify(p));
    this.route.navigate(['/package-details']);
  }

  open(content,details) {
    this.details=details;
    console.log(details);
    this.modalService.open(content, { centered: true });
  }

  custom(){
    this.route.navigate(['/index-custom-booking']);
  }

  pacbyCategory(id) {
    let ar =[]
    this.package=null;
    this.isloading =true;
    this.userService.getPackagebyCategory(id).subscribe(
        res=>{
          if(res.responseCode==200){
            this.isloading=false;
          }
          ar.push(res.data);
          this.package =ar;
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
